import videojs from 'video.js';

const RemainingTimeDisplay = videojs.getComponent('RemainingTimeDisplay');

// AI Playback (SW-6793): when Skip Filler Words / Skip Silences is on, the
// native remaining-time display still counts down against the real file
// duration, since we skip by seeking during playback rather than editing the
// file. This subclass lets useVideoJs push an "effective" remaining-time
// value (real remaining time minus the still-ahead skippable content) in;
// `null` falls back to the native calculation untouched, so the control
// behaves exactly like stock video.js whenever no skip toggle is on.
class AiPlaybackRemainingTimeDisplay extends RemainingTimeDisplay {
  constructor(player, options) {
    super(player, options);
    this.effectiveRemainingSeconds_ = null;
  }

  setEffectiveRemainingSeconds(seconds) {
    this.effectiveRemainingSeconds_ = seconds;
    this.updateContent();
  }

  updateContent(event) {
    if (this.effectiveRemainingSeconds_ === null) {
      super.updateContent(event);
      return;
    }

    const duration = this.player_.duration();
    if (typeof duration !== 'number' || isNaN(duration)) {
      return;
    }

    const time = this.player_.ended() ? 0 : Math.max(0, this.effectiveRemainingSeconds_);
    this.updateTextNode_(time);
  }
}

videojs.registerComponent('AiPlaybackRemainingTimeDisplay', AiPlaybackRemainingTimeDisplay);

export default AiPlaybackRemainingTimeDisplay;
